import { render, staticRenderFns } from "./ReservationStreamItem.vue?vue&type=template&id=bc5703be&scoped=true"
import script from "./ReservationStreamItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./ReservationStreamItem.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./ReservationStreamItem.vue?vue&type=style&index=0&id=bc5703be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc5703be",
  null
  
)

export default component.exports